import React from 'react';

import PropTypes from 'prop-types';

import Spinner from '@/components/common/Spinner';

const FullscreenSpinner = ({ text }) => (
  <div className="fixed inset-0 flex justify-center items-center bg-black/80 z-[9999] animate-in fade-in duration-300">
    <div className="flex items-center p-8 rounded-[3px] bg-white leading-none shadow-[0_0_20px_rgba(0,0,0,0.75)]">
      <div className="w-6 h-6 flex items-center justify-center">
        <Spinner />
      </div>
      <div className="ml-3 text-[15px] font-bold text-[#393939]">
        {text}
      </div>
    </div>
  </div>
);

FullscreenSpinner.propTypes = {
  text: PropTypes.string.isRequired,
};

export default FullscreenSpinner;
